import { render, staticRenderFns } from "./EmployeeTag.vue?vue&type=template&id=67586a9b"
import script from "./EmployeeTag.vue?vue&type=script&lang=ts"
export * from "./EmployeeTag.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67586a9b')) {
      api.createRecord('67586a9b', component.options)
    } else {
      api.reload('67586a9b', component.options)
    }
    module.hot.accept("./EmployeeTag.vue?vue&type=template&id=67586a9b", function () {
      api.rerender('67586a9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/employee/EmployeeTag.vue"
export default component.exports